<script>
    import { createEventDispatcher } from "svelte";
    import EditableSection from "../EditableSection.svelte";
    import TextArea from "../ui/TextArea.svelte";
    import TextInput from "../ui/TextInput.svelte";
    import Socials from "../socials/Socials.svelte";

    const dispatch = createEventDispatcher();

    export let name;
    export let description; 
    export let socials; 
</script>


<EditableSection title={name??"Infos"} on:edit={() => {dispatch("edit")}} on:save={() => {dispatch("save")}}>
    <div slot="edit">
        <TextInput
            label="Name"
            bind:value={name}
        />
        <TextArea
            label="Beschreibungstext"
            bind:value={description}
        />
        <Socials bind:socials mode={"edit"}/>
        <!-- <label>Beschreibungstext<br>
            <textarea bind:value={description} name="description" cols="30" rows="10"></textarea>
        </label> -->
    </div>
    <div slot="view">
        <!-- <span>{name??"Unbenannter Betrieb"}</span><br> -->
        <p>{description??"keine Beschreibung vorhanden..."}</p>
        <Socials bind:socials mode={"view"}/>
    </div>
</EditableSection>